import {
  containsOnlyPermittedPhoneCharacters,
  normalizePhoneDigits,
  PHONE_NUMBER_DIGIT_COUNT,
} from '../validators/phone.validators';

/** Placeholder shown on the masked phone number input. */
export const PHONE_NUMBER_MASK_PLACEHOLDER = '(___) ___-____';

/**
 * Formats partial or complete phone input as (XXX) XXX-XXXX while the user types.
 * Leaves invalid characters and overflow digits untouched so submit validation can reject them.
 */
export function formatPhoneNumberAsYouType(value: string): string {
  if (!value.trim()) {
    return '';
  }

  if (!containsOnlyPermittedPhoneCharacters(value)) {
    return value;
  }

  const digits = normalizePhoneDigits(value);

  if (digits.length > PHONE_NUMBER_DIGIT_COUNT) {
    return value;
  }

  if (digits.length === 0) {
    return '';
  }

  if (digits.length <= 3) {
    return `(${digits}`;
  }

  if (digits.length <= 6) {
    return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  }

  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
}
